import React from "react"
import { connect } from "react-redux"
import { Field , getFormValues , reduxForm , SubmissionError , change} from "redux-form"
import {SubmitButton, TextInput, AnalyticEvent, DirectCall , ToolTip} from "../../../components/forms"
import {CountryListSelectMenu} from "../../../components/forms/countrylist-selectmenu";
import { DomesticCustomer } from "../../../api/domestic-customer";
import {UserRegistration} from "../../../api/user-registration";
import {Errors} from "../../../api/util"
import { EXISTING_QF_CUSTOMER_ROLE } from "../../../api/constants";
import Validators from "../../../validation";

const CompanyInformation = (props) => {
    if(Object.keys(props.customer.company).length === 0 || !props.customer.company.valid){
        return <div/>
    }
    else{
        return (<div>
            <h3>Your account details are</h3>
            <h5>Customer code</h5>
            <p className="code-text">{props.customer.company.customerCode}</p>
        </div>)
    }
};

let GetComponent = (props) => {

    return (
        <div>
            <form className="row widget-form" onSubmit={props.handleSubmit}>
                <section>
                    <h3>What is your customer code or account number?</h3>
                    <Field id="customerCode" name="company.customerCode" placeholder="eg: 11111111; 11111; A11" title="Customer code" component={TextInput}>
                        <ToolTip text="1-7 characters containing letters and numbers assigned to your business account."/>
                    </Field>
                    <Field id="accountNumber" name="company.accountNumber" placeholder="e.g. 1234; 12345678910ABCD" title="Account number" component={TextInput}>
                        <ToolTip text="4-15 characters containing letters and numbers assigned to your business account."/>
                    </Field>
                    <SubmitButton label="LOOKUP CUSTOMER DETAILS"/>
                </section>
            </form>
            <div className={"row"}>
                <a className={"internal-link"} onClick={props.unknownCustomerCodeOrAccount}>I don't know my customer code or account number</a>
            </div>
        </div>
    )
};

GetComponent = reduxForm({form:'domestic/existingcustomer' , destroyOnUnmount: false ,
    asyncBlurFields : ['company.customerCode' , 'company.accountNumber'],
})(GetComponent);
GetComponent = connect(state => {
    return {
        config : getFormValues('config')(state),
        customer : getFormValues('domestic/existingcustomer')(state),
        account : getFormValues('account')(state),
    }
})(GetComponent);

let ViewComponent = (props) => {
    return (
        <div>
            <form className="row widget-form" onSubmit={props.handleSubmit}>
                <section className="lookup-section">
                    <CompanyInformation {...props}/>
                    <h5>Please confirm your company details</h5>
                    <div className="card-item">
                        <div className="card">
                            <h5 className="card__heading">{props.customer.company.name}</h5>
                            <button type="button" aria-label="Edit" onClick={props.edit}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                                    <g fill="#4A4A4A" fillRule="evenodd">
                                        <path
                                            d="M1.975 11.525L0 16l4.475-1.975zM14.425 4.275L16 2.725 13.3 0l-1.575 1.575zM11.025 2.275L2.575 10.7l2.7 2.725L13.725 5z"/>
                                    </g>
                                </svg>
                            </button>
                            <div className="card-details-text">{props.customer.company.streetaddress}</div>
                            <div className="card-details-text">{props.customer.company.city}</div>
                            <div className="card-details-text">{props.customer.company.state}</div>
                            <div className="card-details-text">{props.customer.company.postcode}</div>
                            <div className="card-details-text">{props.customer.company.country.label}</div>
                        </div>
                    </div>
                    <SubmitButton label="CONFIRM & CONTINUE"/>

                </section>

            </form>
            <div className={"row"}>
                <a className="internal-link" onClick={props.back}>Look up another agent code</a>
            </div>
        </div>
    )

};

ViewComponent = connect(state => {

    let registration = getFormValues('registration')(state);
    let customer = getFormValues("domestic/existingcustomer")(state) || { company : { country:{value:"" , label:""} }};
    let company = customer.company || { company : { country : {value:"" , label:""}}};
    let country = company.country || {value:"" , label:""};

    return {
        config : getFormValues('config')(state),
        account : getFormValues('account')(state),
        customer : customer,
        registration : {
            "firstName": registration.firstname,
            "status": "NEW",
            "lastName": registration.lastname,
            "email": registration.email,
            "phone": registration.phone,
            "username": registration.username,
            "password": registration.password,
            "registrationMethod": "DOMESTIC_COMPANY",
            "domesticCompany" : {
                "codes": {
                    "accountNumber": (company.accountNumber && company.accountNumber.trim().length > 0) ? company.accountNumber : null,
                    "customerCode": company.customerCode && company.customerCode.trim().length > 0 ? company.customerCode : null
                },
                "name": company.name,
                "streetAddress": company.streetaddress,
                "userFunctionalRole":EXISTING_QF_CUSTOMER_ROLE,
                "city": company.city,
                "postcode": company.postcode,
                "state": company.state,
                "countryCode": country.value,
                "countryName" : country.label
            }

        }
    }

})(reduxForm({form:'domestic/existingcustomer' , destroyOnUnmount: false })(ViewComponent));

let EditComponent = (props) => {

    return (

        <div>
            <form className="row widget-form" onSubmit={props.handleSubmit}>
                <section className="lookup-section">
                    <CompanyInformation {...props}/>
                    <h3>Please confirm your company details</h3>
                    <Field id="name" name="company.name" placeholder="" title="Company name" component={TextInput}/>
                    <Field id="streetaddress" name="company.streetaddress" maxlength="50" placeholder="" title="Street Address"
                           component={TextInput}/>
                    <Field id="city" name="company.city" placeholder="" title="City" component={TextInput}/>
                    <Field id="state" name="company.state" placeholder="" title="State" component={TextInput}/>
                    <Field id="postcode" name="company.postcode" placeholder="" title="Postcode" component={TextInput}/>
                    <CountryListSelectMenu id="country" name="company.country"/>
                    <SubmitButton label="SAVE CHANGES"/>
                </section>
            </form>
        </div>
    )

};

EditComponent = reduxForm({form:'domestic/existingcustomer' , destroyOnUnmount: false ,
    asyncBlurFields:['company.name' , 'company.streetaddress' , 'company.city' , 'company.state' , 'company.postcode']
})(EditComponent);
EditComponent = connect(state => {
    return {
        config : getFormValues('config')(state),
        customer : getFormValues('domestic/existingcustomer')(state)
    }
})(EditComponent);

class ExistingCustomerContainer extends React.Component {

    constructor(props){
        super(props);
        this.state =  {
            view : 0,
        };
    }

    swapView = (index) => {
        this.setState({ view : index })
    };

    render = () => {

        const handleSubmitSuccess = this.props.handleSubmitSuccess;
        const views = [
            <GetComponent key={1}
                          path={this.props.path}
                          unknownCustomerCodeOrAccount={() => {
                              this.props.dispatch(Errors.clear());
                              this.props.dispatch(change('account' , 'customer' , {value: 'new-customer', label: 'New customer'} ));
                              this.props.dispatch(change('account' , 'howtoregister' , {value: 'company', label: "As a company"} ));
                          }}
                          onSubmitSuccess={(result,dispatch,props) => {
                              dispatch(Errors.clear());
                              this.swapView(1)
                          }}
                          onSubmitFail={(errors,dispatch,submitErrors,props) => {
                              dispatch(Errors.clear());
                              if(submitErrors && submitErrors.errors){
                                  if(submitErrors.errors.status === 404 ){
                                      dispatch(Errors.InvalidFormSubmission([
                                          <li>Enter your company details, so we can set you up.</li>
                                      ], "Sorry, we can't find your details"));
                                      this.swapView(2);
                                  }
                                  else{
                                      dispatch(Errors.TechnicalError());
                                  }
                              }
                          } }
                          onSubmit={(values,dispatch,props) => {
                              dispatch(Errors.clear());
                              const lookup = {
                                  "customerCode" : values.company.customerCode && values.company.customerCode.trim().length > 0 ? values.company.customerCode.trim() : null,
                                  "accountNumber" : values.company.accountNumber && values.company.accountNumber.trim().length > 0 ? values.company.accountNumber.trim() : null
                              };
                              return DomesticCustomer(props.config.customer).validate(lookup).then(
                                  (response) => {
                                      dispatch(change('domestic/existingcustomer', 'company' , response.data) );},
                                  (error) => {
                                      throw new SubmissionError( { _error : error , status : error.status})
                                  }
                              );
                          } }
                          validate={(values) => {return Validators.Company.search.validate(values.company);}}
            />,


            <ViewComponent key={2}
                           path={this.props.path}

                           onSubmitSuccess={(result,dispatch,props) => {
                               AnalyticEvent(window.dataLayer,{
                                   "eventInfo": {
                                       "eventName":"registrationStep4",
                                       "eventAction": "2",
                                   },

                                   "attributes": {
                                       "shippingType": "Within Australia",
                                       "customerType": "Current QF Customer",
                                       "existingCompanyAccount": "No"
                                   }
                               }).then(() => {
                                    DirectCall(window._satellite, "lookupCustomerDetails")
                                }, ()=> {});

                               handleSubmitSuccess(result,dispatch,props)
                           }}
                           onSubmitFail={(errors,dispatch,submitErrors,props) => {
                               AnalyticEvent(window.dataLayer,{
                                   "eventInfo": {
                                       "eventName": "registrationFailed",
                                   }
                               }).then(() => {
                                    DirectCall(window._satellite, "registrationFailed")
                                }, ()=> {});
                               if((submitErrors && submitErrors.errors) || errors){
                                   dispatch(Errors.clear());

                                   if(submitErrors && submitErrors.errors && (submitErrors.errors._error.status === 0 || submitErrors.errors._error.status >= 500 )){
                                       dispatch(Errors.TechnicalError())
                                   }
                                   else if(submitErrors && submitErrors.errors && (submitErrors.errors._error.status >= 400 )){
                                       dispatch(Errors.InvalidFormSubmission());
                                       this.swapView(2)
                                   }
                                   else if(errors || (submitErrors && submitErrors.errors )){
                                       dispatch(Errors.InvalidFormSubmission());
                                   }
                               }
                           } }
                           onSubmit={(values,dispatch,props) => {
                               dispatch(Errors.clear());
                               return UserRegistration(props.config.userreg).Create(props.registration).then(
                                   () => {},
                                   (error) => {
                                       if(error.status === 0 || error.status >= 400 ){
                                           throw new SubmissionError( { status : error.status })
                                       }
                                       else{
                                           throw new SubmissionError( { _error : error.message })
                                       }
                                   }
                               )
                           } }
                           edit={() => { this.swapView(2)} }
                           back={() => {
                               this.props.dispatch(Errors.clear());
                               this.props.dispatch(change('domestic/existingcustomer', 'company.valid' , false ));
                               this.swapView(0) }}
            />,


            <EditComponent key={3}
                           path={this.props.path}
                           onSubmitSuccess={(result,dispatch,props) => {
                                this.swapView(1)
                           }}
                           onSubmitFail={(errors,dispatch,submitErrors,props) => {
                               if((submitErrors && submitErrors.errors) || errors){
                                   dispatch(Errors.clear());

                                   if(submitErrors && submitErrors.errors && (submitErrors.errors._error.status === 0 || submitErrors.errors._error.status >= 500 )){
                                       dispatch(Errors.TechnicalError())
                                   }
                                   else if(submitErrors && submitErrors.errors && (submitErrors.errors._error.status >= 400 )){
                                       dispatch(Errors.InvalidFormSubmission());
                                       this.swapView(2)
                                   }
                                   else if(errors || (submitErrors && submitErrors.errors )){
                                       dispatch(Errors.InvalidFormSubmission());
                                   }
                               }

                           } }
                           onSubmit={(values,dispatch,props) => {
                               dispatch(Errors.clear())
                           } }
                           validate={(values,dispatch,props) => {
                               return Validators.Company.validate(values.company);
                           }}
            />
        ];

        return views[this.state.view]
    }

}

ExistingCustomerContainer = connect( state => {

    return {
        config : getFormValues('config')(state),

        domestic: {

            existingcustomer: getFormValues('domestic/existingcustomer')(state)

        }

    }

})(ExistingCustomerContainer);

export {
    ExistingCustomerContainer
}

